import JsonLd from '@/components/JsonLd';
import { getOrganization, organizationId, siteName } from '@/components/JsonLd/organization';
import { absoluteUrl, siteUrl } from '@/helpers/seo';
import ac_strings from '@/strings/ac_strings.js';
import React from 'react';

/**
 * Site-wide Organization + WebSite structured data. Rendered once (in
 * AppWrapper) so every page carries the publisher identity and a sitelinks
 * search box definition. Nodes are linked by @id so they describe one entity.
 */
const SiteJsonLd: React.FC = () => {
	const lang = String(process.env.LANG_CODE || 'en');
	const websiteId = `${siteUrl}/#website`;

	const organization = getOrganization();

	const website = {
		'@type': 'WebSite',
		'@id': websiteId,
		name: siteName,
		url: siteUrl,
		inLanguage: lang,
		publisher: { '@id': organizationId },
		potentialAction: {
			'@type': 'SearchAction',
			target: absoluteUrl(`${ac_strings.slug_explore}?search={search_term_string}`),
			'query-input': 'required name=search_term_string'
		}
	};

	return (
		<JsonLd
			data={{
				'@context': 'https://schema.org',
				'@graph': [organization, website]
			}}
		/>
	);
};

export default SiteJsonLd;
